<template>
	<span>
		{{ currentTimeHourMinutesFormat }}
	</span>
</template>

<script>
export default {
	name: 'CurrentTimeDisplay',
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	computed: {
		currentTimeHourMinutesFormat() {
			return this.generalInformation?.currentTime?.format('LTS');
		}
	}
};
</script>

<style scoped>

</style>
